











import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Card from '@/stories/utils/card.vue'


@Component({
  components: {
    Card,
  }
})
export default class StorybookUpdateInfo extends Vue {
  get updateInfo() {
    const today = new Date()
    return {
      updatedBy: 'Test name',
      updated: today,
      created: today,
    }
  }
}
